<template>
<div>
    <div class="user-profile ccbs" v-show="finishedLoading">
        <div class="row">
            <div class="col-12 tit_page">
                <div class="float-left">
                    <h1>Assinatura CCB</h1>
                </div>
                <div class="back float-right text-right">
                    <a @click="$router.go(-1)" href="javascript:;" title="Voltar">
                        <i class="back">&nbsp;</i> <span>Voltar</span>
                    </a>
                </div>
            </div>
        </div>
        <hr class="divider">
        <div class="row ccbs__title">
            <div class="col-12">
                <h2>{{(solicitacao.Empresa.NomeFantasia == undefined || solicitacao.Empresa.NomeFantasia == "")? solicitacao.Empresa.RazaoSocial : solicitacao.Empresa.NomeFantasia}}</h2>
            </div>
        </div>
        <hr class="divider">
        <div class="row ccbs__info">
            <div class="col-12 col-md-7 col-lg-8">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Valor solicitado</label>
                            <span>R$ {{formatCurrency(solicitacao.Valor)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Duração</label>
                            <span>{{solicitacao.Prazo}} Meses</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Valor total do empréstimo</label>
                            <span>R$ {{formatCurrency(solicitacao.Prazo*solicitacao.ValorParcela)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Valor da parcela</label>
                            <span>R$ {{formatCurrency(solicitacao.ValorParcela)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Juros</label>
                            <span>{{formatCurrency(solicitacao.TaxaJuros)}}% a.m. </span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Taxa total efetiva</label>
                            <span>{{formatCurrency(solicitacao.CustoEfetivoTotalaa)}}% a.a.</span>
                        </div>
                    </div>

                    <div class="col-12 mt-2 mb-3">
                        <h3>Captação de recursos (investidores)</h3>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Início / Término</label>
                            <span>{{toLocaleDateString(solicitacao.InicioCaptacao)}} - {{toLocaleDateString(solicitacao.FimCaptacao)}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Total de investidores</label>
                            <span>{{solicitacao.QuantidadeReservasInvestimento}}</span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4 mt-2 mb-3">
                        <div class="box p-3">
                            <label>Valor total captado</label>
                            <div class="row no-gutters">
                                <div class="col-8">
                                    <span>R$ {{formatCurrency(solicitacao.ValorCaptado)}}</span>
                                </div>
                                <div class="col-4 text-right">
                                    <span class="text-success">{{formatCurrency((solicitacao.ValorCaptado/solicitacao.Valor) * 100)}}%</span>
                                </div>
                            </div>
                        </div>
                    </div>                 
                </div>

                <div class="row">
                    <div class="col-12">
                        <h3>Lista de CCB’s</h3>
                    </div>
                    <div class="col-12">
                        <div class="table-responsive">
                            <table class="table table-hover">
                                <tbody>
                                    <tr v-for="(pag, index) in reservas" v-bind:key="pag._id">
                                        <th scope="row" class="align-middle">{{index+1}}</th>
                                        <td class="align-middle">
                                            <span class="d-flex align-items-center">
                                                <img src="/static/assets/images/ico-pdf.png" alt="icone ccb">
                                                <small>{{pag.CodigoBMP}}</small>
                                            </span>
                                        </td>
                                        <td class="align-middle"><a :href='CCB_URL+"/imprimirccb.aspx?code="+pag.CodigoBMP+"&copias=1"' class="btn btn-sm btn-link" target="_blank" title="Visualizar CCB">Visualizar</a></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> 
            <aside class="col-12 col-md-5 col-lg-4 mt-2 mb-3">
                <div class="box p-3 p-md-4">
                  
                    <div class="box-form" v-if="passo!= 4">
                        <img src="/static/assets/images/ico-atencao-ccb.svg" class="ico-atencao" alt="icone atenção">
                        <h4>{{Nome()}}, falta assinar sua CCB</h4>

                        <ul class="list-group">
                            <h4>Confirmação dos assinantes</h4>
        
                            <li  v-for="(soc, index) in solicitacao.Empresa.Socios" class="list-group-item d-flex justify-content-between align-items-center">
                               
                               
                                <span class="socio">{{soc.Nome}}<small>&nbsp;<a v-if="VerificaAssinou(soc) != 'ok'" href="#" @click.prevent="ReenviarEmail(soc)">Reenviar email</a></small></span>
                                <span :class='"sing sing-"+ VerificaAssinou(soc)'></span>
                                <!-- <span class="sing sing-ok"></span> -->
                            </li>

                             <li  v-for="(soc, index) in solicitacao.Empresa.Avalistas" class="list-group-item d-flex justify-content-between align-items-center">
                               
                                <span class="socio">{{soc.Nome}}<small>&nbsp;<a v-if="VerificaAssinou(soc) != 'ok'" href="#" @click.prevent="ReenviarEmail(soc)">Reenviar email</a></small></span>
                                <span :class='"sing sing-"+ VerificaAssinou(soc)'></span>
                                <!-- <span class="sing sing-ok"></span> -->
                            </li>
                        </ul>

                        <form v-if="this.passo == 1">
                            <span class="text" v-if="!AssinaturaAssinantesOK()">Só é possível assinar quando todos os sócios/avalistas validarem o token enviado por email.</span>
                            <button class="btn btn-lg btn-primary btn-block" :disabled="!AssinaturaAssinantesOK()" @click.prevent="passo = 2;">Assinar</button>
                            <!-- <button class="btn btn-lg btn-link btn-block">Cancelar</button> -->
                        </form>
                        <form v-if="this.passo == 2">
                            <span class="text">Por favor insira sua senha no campo abaixo para finalizar a assinatura de sua CCB.</span>
                            <input class="form-control form-control-lg" v-model="password" type="password" placeholder="Sua senha aqui">
                            <button class="btn btn-lg btn-primary btn-block" @click.prevent="ValidarSenha()">Assinar</button>
                            <button class="btn btn-lg btn-link btn-block" @click.prevent="passo = passo-1">Cancelar</button>
                        </form>
                        <form v-if="this.passo == 3">
                            <span class="text">Por favor insira o token que foi enviado para o seu celular para finalizar a assinatura de sua CCB.</span>
                            <input class="form-control form-control-lg" v-model="smsToken" type="text" placeholder="Digite seu token aqui">
                            <button class="btn btn-lg btn-primary btn-block" @click.prevent="ValidarToken()">Validar Token</button>
                            <button class="btn btn-lg btn-link btn-block" @click.prevent="passo = passo-1">Cancelar</button>
                        </form>
                    </div>


                    <!-- ínicio mensagem confirmação -->
                    <div class="box-confirm" v-if="passo== 4">
                        <img src="/static/assets/images/icon-success.svg" alt="icone ok">
                        <h5>Obrigado, {{Nome()}}.</h5>
                        <p>As CCB’s foram assinadas com sucesso!</p>
                    </div> 
                    <!-- final mensagem confirmação -->
                </div>
            </aside>
        </div>
    </div>

    <div v-if="!finishedLoading" class="d-flex justify-content-center align-items-center dashboard">
			<div class="dashboard__complete">
				<div class="row">
					<div class="col-12 text-center">
						<h1>Carregando as CCBs...</h1>
					</div>
				</div>
			</div>
		</div>
</div>
</template>

<script>
/* eslint-disable */
    import ApiClient from '../utils/api-client'
    import HubClient from '../utils/hub-consulta-client'
    
	import * as mutationTypes from '@/store/mutation-types.js'
    export default {

        data() {
                return {
                    CCB_URL:process.env.CCB_URL,
                    solicitacao: {
                        Empresa:{
                            Socios:{},
                            Avalistas:{},
                        }
                    },
                    reservas: {},
                    socios: {},
                    passo : 1,
                    password :'',
                    id : '',
                    smsToken : '',
                    tentativas: 3,
                    IP : '',
                    finishedLoading:false
                }
        },
         computed: {

                    User: function () {
                        return this.$store.state.currentUser;
                    }
         },
         methods: {
                formatarTipoEmprestimo(tipoEmprestimo) {
                    if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
                    return "Impacto";
                    }

                    var splitedTipoEmprestimo = tipoEmprestimo.split('-');

                    if (splitedTipoEmprestimo.length > 1) {
                    return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
                    }

                    return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
                },
                ajustIdOportunidade(id, qtd) {
                    var s = String(id);
                    while (s.length < (qtd || 2)) {
                    s = "0" + s;
                    }
                    return s;
                },
                formatCurrency(value) {
                    if (value == null || value == undefined)
                    return parseFloat(0).toLocaleString('pt-BR', {
                        minimumFractionDigits: "2",
                        maximumFractionDigits: 2
                    })

                    return value.toLocaleString('pt-BR', {
                    minimumFractionDigits: "2",
                    maximumFractionDigits: 2
                    })
                },
                toLocaleDateString(value){
                    if(value != undefined){
                        return value.toLocaleDateString('pt-BR');
                    }

                    return "";
                },
                Nome() {
                        var nome = "",
                        letra = "";
                        if (this.User.name == undefined || this.User.name == null || this.User.name == "") {
                        nome = this.User.username;
                        } else {
                        nome = this.User.name;
                        }
                        nome = nome.trim();
                        var primeiroNome = nome.split(" ")[0];
                        return primeiroNome[0].toUpperCase() + primeiroNome.toLowerCase().substring(1);
                    },

                VerificaAssinou(soc){

                    return soc.Assinou ? 'ok' : 'no';
                },
                ReenviarEmail(soc){

                            console.log(soc)
                            ApiClient.get_GO(`out/reenviarEmailSocioCCB/${soc.Token}`)
                            .then(token => {

                              this.$Notify.success("Email enviado!")

                            }).catch((ex) => {}); 
                },

                ValidarSenha() {
                    
                    this.id = this.User._id; 
                    ApiClient.VerificaSenha(this)
                    .then(() => {

                          this.passo = 3;
                          this.password = ''

                        //Chama a api para enviar o token sms para o cliente
                        ApiClient.post('enviar-token-sms', {data: {SolicitacaoId: this.solicitacao._id, AttemptNumber: 1, ConfirmaCliente: true}})
                            .then(() => {
                                this.$Notify.info("SMS enviado com sucesso!")
                                this.tentativas = 3;
                            })
                            .catch(() => {
                                this.$Notify.error("Erro ao enviar o token SMS! Por favor verificar o número de celular!")
                            })
                    })
                    .catch(() => {
                        //Verificação do password
                        this.password = ''
                        this.tentativas --
                        if(this.tentativas == 0) {
                            this.$router.push("/login")
                            this.$Notify.error("Erro: Você excedeu o número de tentativas limite!")
                        }
                        if(this.tentativas != 0)
                            this.$Notify.error("Erro: Senha Inválida! Tentativas restantes: " + this.tentativas)
                    });
                },
                ValidarToken(){

                        //Chama a api para checkar se o token informado é válido
                        ApiClient.post('checar-token-sms', {data: {TokenConfirmacao: this.smsToken, SolicitacaoId: this.solicitacao._id}})
                        .then(() => {
                            
                            this.sms = true;
                            this.passo = 4;
                            
                            ApiClient.get_GO(`out/atualizaSolicitacaoCCBsAssinadas/${this.solicitacao._id}/${this.IP}`)
                            .then().catch((ex) => {});  
                            
                        })
                        .catch((erro) => {

                            this.tentativas --;
                            if(this.tentativas == 0) {
                                this.$router.push("/login")
                                this.$Notify.error("Erro: Você excedeu o número de tentativas limite!")
                            }
                            if(this.tentativas != 0)
                                this.$Notify.error("Erro: Token Inválido! Tentativas restantes: " + this.tentativas)
                        })
                },
                AssinaturaAssinantesOK()
                {
                    
                    if(this.solicitacao.Empresa.Socios != undefined){
                        for(var i = 0 ; i < this.solicitacao.Empresa.Socios.length ; i++){

                            if(this.solicitacao.Empresa.Socios[i].Assinou != true)
                            {
                                return false;
                            }
                        }
                    }

                    if(this.solicitacao.Empresa.Avalistas != undefined){
                        for(var i = 0 ; i < this.solicitacao.Empresa.Avalistas.length ; i++){

                            if(this.solicitacao.Empresa.Socios[i].Assinou != true)
                            {
                                return false;
                            }
                        }
                    }

                    return true;
                },
                getClientAddress() {
                     HubClient.getIP().then(ip => {
                        this.IP = ip;

                        console.log(this.IP)
                    })
                           
               },

               //tagueamento GA
                taggingGA() {
                    this.$ga.page({
                        page: '/emprestimos/formalizar-ccb/:id',
                        title: 'CCB Loan',
                    })
                },
         },
        async created() {

                    if(window.location.href.indexOf("dashboard-app") != -1)

                     this.$store.commit(mutationTypes.START_LOADING)

                    this.getClientAddress();

                    this.solicitacaoId = this.$route.params.id

                    var x = ApiClient.getLoanRequest(this.solicitacaoId)
                        .then(loanRequest => {
                            this.solicitacao = loanRequest;
                            
                            if(this.solicitacao.CCBsAssinaturas == true)
                                this.passo = 4;   
                        })

                    x.then(() => {
                       
                        var email1 = this.solicitacao.Email.trim().toLowerCase();
                        var email2 = this.$store.state.currentUser.email.trim().toLowerCase();

                        if(email1 != email2){ //permissão de visualização somente para o dono da solicitação ( 11/12/2018 - Victor Narcizo)
                        window.location.href="#/";
                        return;
                        }
                        this.$store.commit(mutationTypes.STOP_LOADING)
                        this.finishedLoading = true

                    }).catch(() => {
                        this.finishedLoading = true
                        this.$store.commit(mutationTypes.STOP_LOADING)
                    });


                     ApiClient.getCcbInvestidores(this.solicitacaoId).then(reservas => {
                        this.reservas = reservas.data;
                    })

                    //tagueamento GA
                    await this.taggingGA()
                }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/styles/iouu/variables";
    @import "../assets/styles/iouu/mixins";

    .user-profile {
        .tit_page {
            padding-bottom:0px;
        }
    }

    .table {
        tbody {
            tr {
                &:first-child {
                    th, td {
                       border-top: none!important;
                    }
                }
                th {
                    &:nth-child(1) {
                        width: 6%;
                        color: #000;
                    }
                }
                td {
                    &:nth-child(3) {
                        width: 20%;
                        text-align: right;
                    }
                }
            }

            @include xs {
                tr {
                    th {
                        &:nth-child(1) {
                            width: 12%;
                        }
                    }
                    td {
                        &:nth-child(2) {
                           span {
                               small {
                                   display: none;
                               }
                           }
                        }
                        &:nth-child(3) {
                            width: 40%;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/CCBLoan.vue